import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CPQScreenOption } from '../../../models/CPQUI';

@Component({
  selector: 'app-number-dropdown',
  templateUrl: './number-dropdown.component.html',
  styleUrls: ['./number-dropdown.component.css']
})
export class NumberDropdownComponent implements OnInit {
  @Output() OnChangeEmitter: EventEmitter<any> = new EventEmitter();
  CurrentScreenOption: CPQScreenOption;
  Range: any[];
  constructor() { }

  ngOnInit(): void {
  }

  SetControl(option: CPQScreenOption) {
    debugger;
    var min = -1;
    var max = -1;
    var increment = -1;
    this.Range = [];

    if (option.Ranges.length > 0) {
      min = option.Ranges[0].Min;
      max = option.Ranges[0].Max;
      increment = option.Ranges[0].Increment;
    }

    for (var i = min; i <= max; i++) {
      var arrayItem = { value: i, label: i };
      this.Range.push(arrayItem);
    }


    this.CurrentScreenOption = option;
  }

  onDropdownChange(event: any, autoContinue: number) {
    this.CurrentScreenOption.Value = event.target.value;
    this.OnChangeEmitter.emit(this.CurrentScreenOption);
  }
}
